<div class="ui container">
    <div class="ui large secondary pointing menu">
        <a class="toc item">
            <i class="sidebar icon" (click)="sideBarButtonIsClicked()"></i>
        </a>
        <a (click)="logoClicked()" class="hand"><img class="logo" src="../../../../../../assets/img/logoAndName.png"></a>

        <div class="right item">
            <a class="active item" id="header-trips">Voyages</a>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/trips/navbar/top-navbar/TopTripsNavbar.html